import { useQuery } from '@tanstack/react-query';
import { useConfigStore } from '@jwp/ott-common/src/stores/ConfigStore';
import ContentApiService from '@jwp/ott-common/src/services/ContentApiService';
import { getModule } from '@jwp/ott-common/src/modules/container';

export const useAdSchedule = ({ mediaId }: { mediaId: string }) => {
  const config = useConfigStore.getState().config;
  const contentApiService = getModule(ContentApiService);

  const { isLoading, data } = useQuery({
    queryKey: ['ad-schedule', mediaId],
    queryFn: async () => contentApiService.getAdSchedule({ mediaId, config }),
  });

  return {
    isLoading,
    data,
  };
};
